// extracted by mini-css-extract-plugin
export default {"staleContentWarning":"CommentBox-module__staleContentWarning--Woe29","commentBoxContainer":"CommentBox-module__commentBoxContainer--Y4emm"};